import fetchTweets from "./fetchTweets";
import getTopicsForSpecialism from "./getTopicsForSpecialism";
import getLatestArticles from "./getLatestArticles";
import getPosts from "./getPosts";
import searchResults from "./searchResults";
import talkToUs from "./talkToUs";
import subscribeToNewsletter from "./subscribeToNewsletter";
import requestGatedFile from "./requestGatedFile";
import requestCopy from "./requestCopy";

export default class Api {
  static BASE_URL = "/wp-json/api";

  static fetch = async options => {
    const { endpoint, method = "GET", body, okStatus = 200 } = options;

    let response;

    try {
      response = await fetch(`${Api.BASE_URL}/${endpoint}`, {
        method: method.toUpperCase(),
        body: body ? JSON.stringify(body) : null,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "include"
      });
    } catch (e) {
      throw await Api.errorHandling(null, e);
    }

    if (response.status !== okStatus) {
      throw await Api.errorHandling(response);
    }

    return response;
  };

  static errorHandling = async (response, error = null) => {
    if (!response) {
      return {
        code: "internet_connection",
        message: "Please check your internet connection and try again",
        validation: [],
        error
      };
    }

    if (response.status === 500) {
      return {
        code: "internal_server_error",
        message:
          "Something went wrong while handling your request, please try again",
        validation: [],
        response
      };
    }

    // const body = await response.json();
    // const errorCode = body.code

    return {
      code: "error",
      message: "Something went wrong",
      validation: [],
      response
    };
  };

  static fetchTweets = fetchTweets(Api.fetch);
  static getTopicsForSpecialism = getTopicsForSpecialism(Api.fetch);
  static getLatestArticles = getLatestArticles(Api.fetch);
  static getPosts = getPosts(Api.fetch);
  static searchResults = searchResults(Api.fetch);
  static talkToUs = talkToUs(Api.fetch);
  static subscribeToNewsletter = subscribeToNewsletter(Api.fetch);
  static requestGatedFile = requestGatedFile(Api.fetch);
  static requestCopy = requestCopy(Api.fetch);
}
